// Small marks shared by the landing sections and the promo banner (Figma 29.09 `homepage-v4`).

// Four-point star; the export draws every one of them with this outline at different sizes.
export const Sparkle = ({ size, color, className = '', style }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 22 22"
    fill={color}
    aria-hidden="true"
    className={className}
    style={style}
  >
    <path d="M11 0L13.97 8.03L22 11L13.97 13.97L11 22L8.03 13.97L0 11L8.03 8.03Z" />
  </svg>
)

// 15 x 10 arrow, 1px round stroke, used after CTA and link copy.
export const Arrow = ({ className = '' }) => (
  <svg width="15" height="10" viewBox="0 0 15 10" fill="none" aria-hidden="true" className={`shrink-0 ${className}`}>
    <path
      d="M14.5 5H0.5M8.5 9.5L14.5 5L8.5 0.5"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

// Filled 16px dot with a white tick, optionally inside a ring (`ringClass` sets its size/fill).
export const CheckDot = ({ dotClass, ringClass }) => {
  const dot = (
    <span className={`w-4 h-4 rounded-full flex items-center justify-center shrink-0 ${dotClass}`}>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M4.66 8L7.09 10.6L11.33 6" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </span>
  )
  if (!ringClass) return dot
  return (
    <span className={`rounded-full flex items-center justify-center shrink-0 ${ringClass}`}>{dot}</span>
  )
}

// Pill eyebrow above the hero H1 and The Arvance Way heading.
export const Eyebrow = ({ children, className = '' }) => (
  <p
    className={`inline-flex items-center gap-1.5 h-8 px-[11px] rounded-full border border-brand-fieldBdr bg-brand-pageFill text-brand-dark text-[14px] md:text-[16px] leading-5 font-medium whitespace-nowrap ${className}`}
  >
    <Sparkle size={8.6} color="#4CBC18" />
    {children}
  </p>
)
